<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndDown">
    <v-row>
      <v-col cols="12">
        <h2 class="text-h4 font-weight-black">
          Truncated Cross-sectional Average Length of Life (TCAL)
        </h2>
      </v-col>
      <v-col cols="12" sm="8" lg="9">
        <!-- <p>Truncated Cross-sectional Average Length of Life (TCAL)</p> -->
        <p>
          Truncated Cross-sectional Average Length of Life (TCAL) is a summary
          measure for all of the available mortality history of cohort
          populations, and is the closest measure to the true average longevity
          of populations. Here we used TCAL to identify the cohorts, ages and
          causes of death contributing to differences in survival between Hong
          Kong and high-income countries.
        </p>
        <!-- <p>
          TCAL differences, therefore, will show the survival advantages between
          different populations and the Hong Kong population in this case.
        </p> -->
        <!-- <p>
          This visualisation depicts the survival advantage of Hong Kong
          population in comparison to a specified population by sex, and by
          cause (all causes or specific causes).
        </p> -->
        <v-tabs v-model="selectedTab" centered>
          <v-tab key="all" href="#all">All causes</v-tab>
          <v-tab key="decomposition" href="#decomposition"
            >Cause decomposition</v-tab
          >
          <v-tab key="comparison" href="#comparison">Comparison figure</v-tab>
          <v-tabs-slider></v-tabs-slider>
          <v-tab-item
            value="all"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <v-row v-if="selectedGender && selectedCountry">
              <v-col cols="12" sm="6" class="flex-grow-0 flex-shrink-0">
                <v-row justify="center">
                  <v-card>
                    <v-card-text class="text-subtitle-1 text-center">
                      <!-- <h4>
                        Lexis surface of the cumulative age- and cohort-
                        difference in all-cause TCALs among
                        {{ selectedGender }}s between Hong Kong and
                        {{ selectedCountry.text }} in 1979-2016
                      </h4> -->
                      Lexis surface of cumulative cohort survival comparisons
                      between Hong Kong and {{ selectedCountry.text }} among
                      {{ selectedGender }}s in 1979-2016
                    </v-card-text>
                    <v-img
                      class="mx-auto"
                      style="margin: 0 auto"
                      max-width="350"
                      contain
                      :src="
                        tcalsImages[
                          `cumulative-${selectedCountry.value}-${selectedGender}`
                        ]
                      "
                    >
                    </v-img>
                  </v-card>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="flex-grow-0 flex-shrink-0">
                <v-row justify="center">
                  <v-card>
                    <v-card-text class="text-subtitle-1 text-center">
                      Lexis surface of non-cumulative cohort survival
                      comparisons between Hong Kong and
                      {{ selectedCountry.text }} among {{ selectedGender }}s in
                      1979-2016
                      <!-- <h4>
                        Lexis surface of the non-cumulative age- and cohort-
                        difference in all-cause TCALs among
                        {{ selectedGender }}s between Hong Kong and
                        {{ selectedCountry.text }} in 1979-2016
                      </h4> -->
                    </v-card-text>
                    <v-img
                      class="mx-auto"
                      max-width="350"
                      contain
                      :src="
                        tcalsImages[
                          `non-cumulative-${selectedCountry.value}-${selectedGender}`
                        ]
                      "
                    ></v-img>
                  </v-card>
                </v-row>
              </v-col>
              <v-col cols="12">
                Note: The blue areas correspond to the survival advantage in
                Hong Kong, while the yellow/red areas correspond to the survival
                advantage in {{ selectedCountry.text }}. The cause decomposition
                of TCAL comparison was analyzed over ICD-9 and ICD-10 codes.
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item
            value="decomposition"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <v-row v-if="selectedGender && selectedCountry && selectedDisease">
              <v-col cols="12" sm="6" class="flex-grow-0 flex-shrink-0">
                <v-row justify="center">
                  <v-card>
                    <v-card-text class="text-subtitle-1 text-center">
                      <!-- <h4>
                        Lexis surface of the cumulative age- and cohort-
                        difference in {{ selectedDisease.text }} TCALs among
                        {{ selectedGender }}s between Hong Kong and
                        {{ selectedCountry.text }} in
                        {{
                          specialRange[selectedCountry.text]
                            ? specialRange[selectedCountry.text]
                            : "1979-2016"
                        }}
                      </h4> -->
                      Lexis surface of the
                      {{ selectedDisease.text }} contribution to the cumulative
                      difference in cohort survival between Hong Kong and
                      {{ selectedCountry.text }} in
                      {{
                        specialRange[selectedCountry.text]
                          ? specialRange[selectedCountry.text]
                          : "1979-2016"
                      }}
                    </v-card-text>
                    <v-img
                      class="mx-auto"
                      max-width="350"
                      contain
                      :src="
                        tcalsImages[
                          `cumulative-${selectedCountry.value}-${selectedDisease.value}-${selectedGender}`
                        ]
                      "
                    ></v-img>
                  </v-card>
                </v-row>
              </v-col>
              <v-col cols="12" sm="6" class="flex-grow-0 flex-shrink-0">
                <v-row justify="center">
                  <v-card>
                    <v-card-text class="text-subtitle-1 text-center">
                      <!-- <h4>
                        Lexis surface of the non-cumulative age- and cohort-
                        difference in {{ selectedDisease.text }} TCALs among
                        {{ selectedGender }}s between Hong Kong and
                        {{ selectedCountry.text }} in
                        {{
                          specialRange[selectedCountry.text]
                            ? specialRange[selectedCountry.text]
                            : "1979-2016"
                        }}
                      </h4> -->
                      Lexis surface of the
                      {{ selectedDisease.text }} contribution to the
                      non-cumulative difference in cohort survival between Hong
                      Kong and {{ selectedCountry.text }} in
                      {{
                        specialRange[selectedCountry.text]
                          ? specialRange[selectedCountry.text]
                          : "1979-2016"
                      }}
                    </v-card-text>
                    <v-img
                      class="mx-auto"
                      max-width="350"
                      contain
                      :src="
                        tcalsImages[
                          `non-cumulative-${selectedCountry.value}-${selectedDisease.value}-${selectedGender}`
                        ]
                      "
                    ></v-img>
                  </v-card>
                </v-row>
              </v-col>
              <v-col cols="12">
                Note: The blue areas correspond to the survival advantage in
                Hong Kong, while the yellow/red areas correspond to the survival
                advantage in {{ selectedCountry.text }}. The cause decomposition
                of TCAL comparison was analyzed over ICD-9 and ICD-10 codes.
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item
            value="comparison"
            reverse-transition="fade-transition"
            transition="fade-transition"
          >
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>
                    <h4
                      class="text-center"
                      style="width: 100%; word-break: break-word"
                    >
                      Cause of death contribution to differences in cohort
                      survival between<br />Hong Kong and high-income countries
                    </h4>
                  </v-card-title>
                  <v-img :src="levelOfConfidenceImage"> </v-img>
                  <v-card-text class="text-caption">
                    Note: Positive values indicate that Hong Kong has a survival
                    advantage compared to the specific country/group. The size
                    of the bubbles corresponds to the 95% Confidence Intervals.
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-row v-if="selectedLevelOfConfidence && selectedGender">
              <v-col
                cols="12"
                v-for="image in confidenceImages[
                  `${selectedGender}${selectedLevelOfConfidence}`
                ]"
                :key="image"
              >
                <v-img :src="image" contain></v-img>
              </v-col>
            </v-row> -->
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col cols="12" sm="4" lg="3">
        <v-card>
          <v-card-text>
            <!-- <p>Instructions:</p>
            <ul>
              <li>
                If you would like to look at ALL-CAUSE MORTALITY…
                <ul>
                  <li>
                    Please select the sex (e.g. male) and country (e.g.
                    Australia) of interest.
                  </li>
                </ul>
              </li>
              <li>
                If you would like to look at CAUSE-SPECIFIC MORTALITY…
                <ul>
                  <li>
                    Please select the sex (e.g. male) and country (e.g.
                    Australia) of interest, as well as the broad or specific
                    cause of death (e.g. Cancer, or Lung Cancer)
                  </li>
                </ul>
              </li>
              <li>
                If you would like to look at COMPARISON OF TCAL DIFFERENCES BY
                BROAD CAUSE AMONG ALL HICs
                <ul>
                  <li>Please select the sex (e.g. male) of interest.</li>
                </ul>
              </li>
            </ul> -->
            <v-radio-group
              v-model="selectedGender"
              label="Select sex"
              :disabled="selectedTab === 'comparison'"
            >
              <v-radio
                v-for="gender in genders"
                :disabled="
                  selectedDisease && selectedDisease[gender.value] === false
                "
                :key="gender.value"
                :value="gender.value"
                :label="gender.text"
              ></v-radio>
            </v-radio-group>
            <v-select
              :disabled="selectedTab === 'comparison'"
              rounded
              outlined
              v-model="selectedCountry"
              :items="countries"
              label="Select country"
              dense
              return-object
            ></v-select>

            <v-select
              dense
              :disabled="selectedTab !== 'decomposition'"
              rounded
              outlined
              v-model="selectedDisease"
              return-object
              label="Select disease"
              :items="diseases"
            >
              <template #item="{ item, attrs }">
                <template v-if="item.specific">
                  <v-list-item-action class="ma-0 pa-0"></v-list-item-action>
                  <v-list-item-action class="mr-6">
                    <v-checkbox v-model="attrs.inputValue"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </template>
                <template v-else>
                  <v-list-item-action>
                    <v-checkbox v-model="attrs.inputValue"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </template>
              </template>
            </v-select>

            <!-- <v-select
              dense
              :disabled="selectedTab !== 'comparison'"
              rounded
              outlined
              v-model="selectedLevelOfConfidence"
              :items="levelOfConfidence"
              label="Select level of confidence"
            ></v-select> -->
            <!-- <v-select
            label="Select sex"
            rounded
            outlined
            v-model="selectedGender"
            :items="genders"
            ></v-select>-->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import diseases from "../data/diseases";
import countries from "../data/countries.js";
import genders from "../data/genders.js";
import tcalsImages from "../assets/tcals";
import confidenceImages from "../assets/tcals/confidence";
import levelOfConfidenceImage from "../assets/CIplot20210608.png";
// import levelOfConfidence from "../data/levelOfConfidence";

export default {
  name: "Tcals",
  data: () => ({
    specialRange: {
      Germany: "1990-2016",
      Denmark: "1994-2015",
      Portugal: "1980-2016",
      Spain: "1980-2016",
      Sweden: "1987-2016",
      Finland: "1987-2016",
      Switzerland: "1995-2016",
      Norway: "1986-2016",
    },
    levelOfConfidenceImage,
    selectedCountry: null,
    selectedDisease: null,
    selectedGender: null,
    selectedTab: null,
    selectedLevelOfConfidence: null,
    tcalsImages,
    confidenceImages,
    // levelOfConfidence,
    genders,
    countries,
    diseases,
    images: {},
  }),
  computed: {},
  methods: {},
  created() {},
};
</script>

<style></style>
